import axios, { CancelToken, CancelTokenStatic } from 'axios'
import { Source } from '../models/Source'
import Booking from '../models/Booking'
import AdditionalBookingType from '../models/AdditionalBookingType';

export interface BookingUrlParams {
    source?: Source,
    affiliateId?: string,
    customSource?: string,
    returnUrl?: string,
    googleAnalyticsCode?: string,
    googleTagManagerCode?: string,
    stylesheet?: string,
    locale?: string,
}

export default abstract class ApiProvider {
    baseUrl: string
    urlOptions: BookingUrlParams = {}
    websiteBase: string

    constructor () {
        this.baseUrl = ApiProvider.getApiBase()
        this.websiteBase = ApiProvider.getWebsiteBase()
    }

    setUrlOptions (urlOptions: BookingUrlParams): this {
        this.urlOptions = urlOptions

        return this
    }

    static get CancelToken (): CancelTokenStatic {
        return axios.CancelToken
    }

    static isCancelledRequest (response: any): boolean {
        return axios.isCancel(response)
    }

    static getWebsiteBase (): string {
        return process.env.WEBSITE_BASE
    }

    static getApiBase (): string {
        return process.env.API_BASE
    }

    get (url: string, options: any = {}): Promise<any> {
        return axios.get(url, options)
    }

    post (url: string, data: any, options = {}): Promise<any> {
        return axios.post(url, data, options)
    }

    objToParams (obj: any): string {
        return ApiProvider.objToParams(obj, this.urlOptions || {})
    }

    static buildObject(obj: any, urlParams: BookingUrlParams) {
      if (urlParams.source) {
        obj.source = urlParams.source
      }

      if (urlParams.affiliateId) {
        obj.affiliate_id = urlParams.affiliateId
      }

      if (urlParams.customSource !== null) {
        obj.partner_source = urlParams.customSource
      }

      if (urlParams.returnUrl) {
        obj.return_url = urlParams.returnUrl
        obj.return_method = 'post'
      }

      if (urlParams.googleAnalyticsCode) {
        obj.ga_account = urlParams.googleAnalyticsCode
      }

      if (urlParams.googleTagManagerCode) {
        obj.gtm_account = urlParams.googleTagManagerCode
      }

      if (urlParams.stylesheet) {
        obj.stylesheet = urlParams.stylesheet
      }

      if (urlParams.locale) {
        obj.locale = urlParams.locale
      }

      return obj;
    }

    static objToParams (obj: any, urlParams: BookingUrlParams): string {
        obj = ApiProvider.buildObject(obj, urlParams);

        let str = '?'

        for (let key in obj) {
          str += encodeURIComponent(key) + '=' + obj[key] + '&'
        }

        return str.slice(0, -1)
    }

    static createQueryParams (booking: Booking, urlParams: BookingUrlParams, additionalTypes: Array<AdditionalBookingType>) {
      const obj = booking.toQuery()

      let tagsString: { [index in string]: any } = {}

      if (obj.tags) {
        obj.tags.forEach((tag: any) => {
          tagsString[tag.id] = tag.value
        })
      }

      obj.tags = JSON.stringify(tagsString)

      if(additionalTypes && additionalTypes.length) {
        let additionalTypesJson : Array<object> = []
        additionalTypes.forEach(function (type: AdditionalBookingType, index: number) {
          additionalTypesJson[index] = {
            id: type.id,
            time: type.startTime.time.str,
            duration: type.duration
          }
        })

        obj.additionalTypes = JSON.stringify(additionalTypesJson)
      }

      return ApiProvider.buildObject(obj, urlParams)
    }

    static getBookingUrl () {
      return ApiProvider.getWebsiteBase() + '/book'
    }
}



// WEBPACK FOOTER //
// ./src/services/ApiProvider.ts